import type { InputTheme } from '@app/components/Input/types';

export const colors = {
  white: '#FFF',
  black: '#373A3C',
  //  Gray colors:
  gray: '#777',
  light_gray: '#979797',
  light_gray2: '#d9d9d9',
  //  Blue colors:
  light_blue: '#1677ff',
  blue: '#0275D8',
  //  Yellow colors:
  yellow: '#FFDE31',
  //  Green colors:
  green: '#0FCC5B',
  //  Red colors:
  red: '#E14F4F',
  //  Other colors:
  transparent: 'transparent',
};

const shadows = {
  blue_shadow: '0 0 0 2px rgba(5, 145, 255, 0.1)',
};
const { black, gray, white, red, blue, light_gray2, light_blue } = colors;

const { blue_shadow } = shadows;

export const inputTheme: InputTheme = {
  default: {
    background: white,
    text: black,
    shadow: 'none',
    border: light_gray2,
  },
  hover: {
    background: white,
    text: black,
    shadow: blue_shadow,
    border: blue,
  },
  focus: {
    background: white,
    text: black,
    shadow: blue_shadow,
    border: light_blue,
  },
  fill: {
    background: white,
    text: black,
    shadow: 'none',
    border: light_gray2,
  },
  disabled: {
    background: 'rgba(0, 0, 0, 0.04)',
    text: gray,
    shadow: 'none',
    border: light_gray2,
  },
  error: {
    background: white,
    text: black,
    shadow: 'none',
    border: red,
  },
};
